var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"loading":_vm.loading,"classical":true,"title":_vm.topicData.commodityGroupTitle}},[_c('x-icon',{class:_vm._.headImage,attrs:{"src":_vm.topicData.commodityGroupBackgroundPic}}),_c('div',{class:_vm._.list},[_c('x-goods-waterfall',{attrs:{"load":_vm.handleLoadData,"one":true,"has-serial-no":true,"track":{
        name: '榜单商品',
        id: '57c696b0-1929-4c60-84ba-5f29688bb94b',
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }